import { useWeb3React } from "@web3-react/core";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Web3 from "web3";
import Account from "../Components/Account/Account";
import ImageDropZone from "../Components/UI/ImageDropZone";
import LinkWithSearchParams from "../Components/UI/LinkWithSearchParams";
import LoadingBar from "../Components/UI/LoadingBar";
import {
    updateProfile,
    uploadToIpfs,
    updateAssetsByWallet,
} from "../utils/apis";
import { showToast } from "../utils/hot-toast";

import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { TbRefreshDot } from "react-icons/tb";
import { useStore } from "../utils/store";

const ProfileSettings = () => {
    const fetchProfile = useStore((state) => state.fetchProfile);

    const profile = useStore((state) => state.profile);

    const navigate = useNavigate();
    const { account, library } = useWeb3React();
    const usernameRef = useRef(null);
    const bioRef = useRef(null);
    // const siteLinkRef = useRef(null);

    const [notice, setNotice] = useState("");

    const [avatarImg, setAvatarImg] = useState("");

    const [bannerImg, setBannerImg] = useState();

    useEffect(() => {
        if (account) {
            loadProfile();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [account]);

    const loadProfile = async () => {
        await fetchProfile(account);
        setAvatarImg(profile?.avatarLink);
        if (!profile) {
            showToast(
                "ERROR",
                "There is no profile registered with this wallet address!"
            );
            navigate("/profile");
        }
    };

    const submitProfile = async () => {
        try {
            const usernameRegex = /^[a-zA-Z0-9]+$/;
            if (!usernameRegex.test(usernameRef.current.value)) {
                setNotice("");
                showToast(
                    "INFO",
                    "Invalid username format! You can set only alphabets and numbers."
                );
                return;
            }
            const web3 = new Web3(library.provider);
            window.web3 = web3;

            const nonce = profile.uuid;
            setNotice("Verifing the ownership of this profile...");

            const signatureHash = await web3.eth.personal.sign(nonce, account);
            const updateObject = {
                signatureHash,
                username: usernameRef.current.value,
                bio: bioRef.current.value,
            };
            if (avatarImg) updateObject.avatarLink = avatarImg;
            if (bannerImg) {
                setNotice("Uploading the Banner image to IPFS 🌍...");
                updateObject.bannerLink = await uploadToIpfs(bannerImg);
            }
            setNotice("Updating the database...");
            const result = await updateProfile(account, updateObject);
            fetchProfile(account);
            if (result) {
                showToast("SUCCESS", "Profile was updated successfully!");
                setNotice("");
                return;
            }
            setNotice("");
            showToast("ERROR", "Signature verfication failed!");
        } catch (error) {
            setNotice("");
            showToast("ERROR", "Signature verfication failed!");
        }
    };

    const updateProfileAssets = async () => {
        await updateAssetsByWallet(account);
        fetchProfile(account);
    };

    const profileUpdateInputArr = [
        {
            name: "Username",
            warning: "*",
            placeholder: "Enter username",
            width: "w-full",
            type: "input",
            ref: usernameRef,
            value: profile?.username,
        },
        {
            name: "Bio",
            placeholder: "Tell the world your story!",
            width: "w-full",
            type: "textarea",
            ref: bioRef,
            value: profile?.bio,
        },
        // {
        //     name: "External Link",
        //     placeholder: "yoursite.io",
        //     width: "w-full",
        //     type: "input",
        //     ref: siteLinkRef,
        // },
        {
            name: "Wallet Address",
            placeholder: account,
            width: "w-full",
            type: "input",
            disabled: true,
        },
    ];
    if (!account)
        return (
            <div className="main-container animation-fade-in flex flex-col">
                <h3 className="text-center">Connect your wallet</h3>
                <h5 className="page-subtitle">
                    If you don't have a wallet yet, you can select a provider
                    and create one now.
                </h5>
                <Account
                    modalstyle={false}
                    buttonclassname="thiGr-button rounded-lg mx-auto size-1"
                />
            </div>
        );
    return (
        <div className="main-container animation-fade-in relative">
            {notice.length !== 0 && (
                <div className="absolute -left-4 -right-4 top-12 lg:top-20 -bottom-4 backdrop-blur-sm z-[5] flex items-center justify-center">
                    <LoadingBar text={notice} />
                </div>
            )}

            <div className="md:bg-kadItemDarkBg relative shadow-lg mx-auto w-full lg:w-7/12 rounded-lg py-8">
                <LinkWithSearchParams
                    to={{
                        pathname: "/profile",
                    }}
                    className="absolute top-4 right-4 size-sm rounded-full px-2 py-1 font-normal border border-kadComponentBorder hover:bg-kadComponentBorder duration-150 cursor-pointer"
                >
                    Preview
                </LinkWithSearchParams>
                <h3 className="text-center">Profile Settings</h3>
                <h5 className="page-subtitle">
                    Customize your public profile to attract visitors!
                </h5>

                <div className="flex flex-col gap-5 md:mx-6 pt-4">
                    {profileUpdateInputArr.map((el, i) => (
                        <div key={i} className="w-full flex flex-col">
                            <span className="size-sm text-kadComponentActive font-normal uppercase mb-2">
                                {el.name}{" "}
                                <span className="text-kad-gradient">
                                    {el.warning}
                                </span>
                                {el.type === "input" && (
                                    <input
                                        className="smooth-input w-full"
                                        placeholder={el.placeholder}
                                        ref={el.ref}
                                        disabled={el.disabled && true}
                                        defaultValue={el.value}
                                    />
                                )}
                                {el.type === "textarea" && (
                                    <textarea
                                        className="smooth-input w-full"
                                        placeholder={el.placeholder}
                                        ref={el.ref}
                                        defaultValue={el.value}
                                    />
                                )}
                            </span>
                        </div>
                    ))}
                    <div className="w-full flex flex-col">
                        <span className="text-kadComponentActive mb-2">
                            Profile Image (Choose one from your NFTs){" "}
                        </span>
                        {/* <div className="bg-[#282837] overflow-hidden rounded-lg border-2 border-dashed border-[#494949] w-60 aspect-square">
                            <ImageDropZone
                                imageObject={avatarImg}
                                setImageObject={setAvatarImg}
                            />
                        </div> */}

                        <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
                            {profile?.nftAssets?.length > 0 &&
                                profile?.nftAssets?.map(
                                    (asset, index) =>
                                        !!asset?.externalData?.image && (
                                            <div
                                                key={index}
                                                className={`flex flex-col relative p-2 border border-kadComponentBorder rounded-lg cursor-pointer group hover:text-kadGr2St hover:bg-kadComponentBg duration-150 
                                                ${
                                                    avatarImg ===
                                                    asset.externalData.image
                                                        ? "bg-kadComponentBg"
                                                        : ""
                                                }`}
                                                onClick={() => {
                                                    setAvatarImg(
                                                        asset.externalData.image
                                                    );
                                                }}
                                            >
                                                {avatarImg ===
                                                    asset.externalData.image &&
                                                    index ===
                                                        profile?.nftAssets.findIndex(
                                                            (temp) =>
                                                                temp
                                                                    .externalData
                                                                    .image ===
                                                                avatarImg
                                                        ) && (
                                                        <IoMdCheckmarkCircleOutline className="absolute size-2 fill-kadGrSt" />
                                                    )}
                                                <img
                                                    alt="nft avatar"
                                                    src={
                                                        asset.externalData.image
                                                    }
                                                    className="border-b border-kadComponentBorder rounded-t-lg group-hover:sepia"
                                                />
                                                <span className="size-base">
                                                    {asset.externalData.name ||
                                                        asset.contract_symbol}
                                                </span>
                                            </div>
                                        )
                                )}
                            <button
                                className="group min-h-[10rem] flex items-center justify-center border border-kadComponentBorder rounded-lg hover:bg-kadComponentBg duration-150"
                                onClick={updateProfileAssets}
                            >
                                <span className="block group-hover:hidden animation-fade-in">
                                    Click to Refresh NFTs
                                </span>
                                <span className="hidden group-hover:flex animation-fade-in items-center">
                                    <TbRefreshDot className="size-4 animate-[spin_1.5s_linear_infinite]" />
                                </span>
                            </button>
                        </div>
                    </div>
                    <div className="w-full flex flex-col">
                        <span>Profile Banner</span>
                        <div className="bg-[#282837] rounded-lg border-2 border-dashed border-[#494949] w-full aspect-[4/1] lg:aspect-[5/1]">
                            <ImageDropZone
                                imageObject={bannerImg}
                                setImageObject={setBannerImg}
                            />
                        </div>
                    </div>
                </div>
                <button
                    className="blueGradient-button w-48 mt-8 mx-auto"
                    onClick={submitProfile}
                >
                    Save
                </button>
            </div>
        </div>
    );
};

export default ProfileSettings;
